// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export interface ApiErrorDetails {
  title?: string;
  status?: number;
  detail?: string;
  errors?: Record<string, string[] | string>;
}

export class ApiServiceError extends Error {
  public readonly name = "ApiServiceError";

  constructor(
    message: string,
    public readonly status: number,
    public readonly statusText: string,
    public readonly responseBody: string,
    public readonly details?: ApiErrorDetails,
    public readonly retryAfter?: string | undefined,
  ) {
    super(message);
  }
}
